import { BadgeCheck, Crown, Shield, Star, Gem, Code, Heart, Sparkles } from "lucide-react";

export const PRESET_BADGES = ["Premium", "Verified", "Admin", "Staff", "VIP", "OG", "Developer", "Supporter"];

const CONFIG = {
  Premium: { icon: Crown, color: "text-amber-400", bg: "bg-amber-400/10 border-amber-400/30" },
  Verified: { icon: BadgeCheck, color: "text-sky-400", bg: "bg-sky-400/10 border-sky-400/30" },
  Admin: { icon: Shield, color: "text-rose-400", bg: "bg-rose-400/10 border-rose-400/30" },
  Staff: { icon: Sparkles, color: "text-violet-400", bg: "bg-violet-400/10 border-violet-400/30" },
  VIP: { icon: Gem, color: "text-fuchsia-400", bg: "bg-fuchsia-400/10 border-fuchsia-400/30" },
  OG: { icon: Star, color: "text-emerald-400", bg: "bg-emerald-400/10 border-emerald-400/30" },
  Developer: { icon: Code, color: "text-cyan-400", bg: "bg-cyan-400/10 border-cyan-400/30" },
  Supporter: { icon: Heart, color: "text-pink-400", bg: "bg-pink-400/10 border-pink-400/30" },
};

export function BadgeIcon({ name, size = 16 }) {
  const c = CONFIG[name];
  if (!c) return null;
  const Icon = c.icon;
  return (
    <span
      title={name}
      data-testid={`badge-${name.toLowerCase()}`}
      className={`inline-flex items-center justify-center w-7 h-7 rounded-lg border ${c.bg}`}
    >
      <Icon className={c.color} style={{ width: size, height: size }} />
    </span>
  );
}

export function BadgePill({ name }) {
  const c = CONFIG[name] || CONFIG.Verified;
  const Icon = c.icon;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${c.bg} ${c.color}`}>
      <Icon className="w-3.5 h-3.5" /> {name}
    </span>
  );
}
